import React from 'react';
import { connect } from 'react-redux';
import Draggable from 'react-draggable';
import { reduxForm, SubmissionError } from 'redux-form';
import MaterialTable from "material-table";
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Paper from '@material-ui/core/Paper';
import * as actions from '../../Actions/bankfeeds';
import css from './bfm.css';
import ShareAccessForm from './ShareAccessForm';
import SendEmailForm from './SendEmailForm';
import { shareEmailTemp } from '../Common/SelectLists';

const shareEmail = {};

class ShareAccessModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { title: "First Name", field: "FirstName", type: "string", cellStyle: {width: "120px", paddingRight: "0px"}  },
        { title: "Last Name", field: "LastName", type: "string", cellStyle: {width: "120px", paddingRight: "0px"} },
        { title: "Email", field: "EmailAddress", type: "string", cellStyle: {width: "200px", paddingRight: "0px"}  },
        { title: "Last Login", field: "LastLoginDate", type: "date", cellStyle: {width: "120px", paddingRight: "0px"} }
      ],
      actions: [
        {
          icon: 'add',
          tooltip: 'Add User',
          isFreeAction: true,
          onClick: event => this.handleClickOpen()
        },
        {
          icon: 'send',
          tooltip: 'Invite again',
          onClick: (event, data) => this.handleSendEmail(event, data)
        }
      ],
      open: false,
      showMessage: false,
      modalType: '',
      modalSize: 'sm'
    };
  }

  componentWillMount() {
    this.props.getBankFeedShares();
  }

  handleSendEmail = (event, data) => {
    this.handleEmailClickOpen();
    shareEmail.email = data.EmailAddress;
    shareEmail.message = shareEmailTemp.message.replace('[FIRST_NAME]', data.FirstName);
  }

  sendEmail = ({ message }) => {
    if (message.trim() === "") throw new SubmissionError({ message:  "Enter a message" });
    this.props.sendEmail(shareEmail.email, message);
  }

  sentEmail = () => {
    this.setState({showMessage: true});
    this.handleClose();
  }
  
  handleClickOpen = () => {
    this.setState({open: true, modalType: 'Add Share Access', modalSize: 'sm'});
  }

  handleClose = () => {
    this.setState({open: false});
    this.props.clearShareState();
  }

  handleEmailClickOpen = () => {
    this.setState({open: true, modalType: 'Send Email', modalSize: 'md'});
    this.props.clearShareState();
  }

  handleShare = values => {
    const error = {};

    if (values.firstName === undefined) error.firstName = "Enter a first name";
    if (values.lastName === undefined) error.lastName = "Enter a last name";
    if (values.emailAddress === undefined) error.emailAddress = "Enter an email";
    if (Object.getOwnPropertyNames(error).length !== 0) throw new SubmissionError(error);

    shareEmail.email = values.emailAddress;
    shareEmail.message = shareEmailTemp.message.replace('[FIRST_NAME]', values.firstName);

    this.props.addBankFeedShare(values);
  }

  isCurrentUser = userId => {
    let currentUserId = this.props.xpa.userid;
    return currentUserId === userId;
  }

  renderTextField = ({
    input,
    label,
    meta: { touched, error },
    ...custom
  }) => (
    <div>
      <TextField
        {...input}
        {...custom}
      />
      <div className={css.red}>{touched && error}</div>
    </div>
  );

  PaperComponent = props => (
      <Draggable handle={'[id*="scroll-dialog-title"]'}>
        <Paper {...props} />
      </Draggable>
  )

  render() {
    const { modalType } = this.state;
    const { feedLoading, shareList } = this.props.bankfeeds;
    
    let shares = [];
    if (shareList !== undefined) shares = shareList.shares;

    if (this.props.bankfeeds.added) {
      setTimeout(() => this.handleEmailClickOpen(), 1500);
    }
    if (this.props.bankfeeds.sent) {
      setTimeout(() => this.sentEmail(), 1500);
    }

    return (
      <div>
        <Grid>
          <MaterialTable
            title=""
            columns={this.state.columns}
            data={shares}
            isLoading={feedLoading}
            options={{
                actionsColumnIndex: -1,
                rowStyle: rowData => ({
                  backgroundColor: this.isCurrentUser(rowData.UserId) ? '#F7F7F7' : '#FFF'
            })}}
            actions={this.state.actions}
            localization={{
              body: {
                deleteTooltip: "Delete",
                editRow: {
                  deleteText: "Are you sure you want to delete this user?"
                }
              },
            }}
            editable={{
              isEditable: rowData => true,
              isDeletable: rowData => !this.isCurrentUser(rowData.UserId),
              onRowDelete: oldData =>
                new Promise(resolve => {
                  this.props.deleteBankFeedShare(oldData.EmailAddress);
                  resolve();
                }),
            }}
          />
        </Grid>

        <Dialog 
          className={css.dialogFont} 
          open={this.state.open} 
          onClose={this.handleClose} 
          fullWidth={true} 
          maxWidth={this.state.modalSize} 
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          scroll="paper"
          PaperComponent={this.PaperComponent}
          >
          <DialogTitle id="scroll-dialog-title" style={{ cursor: 'move' }}>{modalType}</DialogTitle>
          {modalType === 'Add Share Access' && <ShareAccessForm onSubmit={this.handleShare} onClose={this.handleClose} renderTextField={this.renderTextField} />}
          {modalType === 'Send Email' && <SendEmailForm initialValues={shareEmail} onSubmit={this.sendEmail} onClose={this.handleClose} renderTextField={this.renderTextField} />}
        </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        key={0}
        open={this.state.showMessage}
      >
        <SnackbarContent 
          message={<span id="message-id">Email sent!</span>} 
          action={[
              <IconButton key="close" aria-label="close" color="inherit" onClick={() => this.setState({showMessage: false})}>
                <CloseIcon fontSize = "small" />
              </IconButton>,
          ]}
          onClose={() => this.setState({showMessage: false})}
        />
      </Snackbar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { bankfeeds, xpa } = state;
  return { bankfeeds, xpa };
}

export default ShareAccessModal = connect(
  mapStateToProps, 
  actions
)(
  reduxForm({
    form: 'shareAccessModal'
  })(ShareAccessModal)
);



// WEBPACK FOOTER //
// ./src/components/FeedManagment/ShareAccessModal.js